import React from 'react';
import Header from '../../components/Header/Header';
import Hero3 from '../../components/Hero3/Hero3';
import PriceList from '../../components/PriceList/PriceList';
import Footer from '../../components/Footer/Footer';

const Page3 = () => {
  return (
    <div>
      <Header />
      <Hero3 />
      <PriceList />
      <Footer />
    </div>
  );
};

export default Page3;
